import '../App.css';
import HeaderBar from '../HeaderObject.js';
import FooterBar from '../FooterObject.js';
import Banner from '../banner.js';
import SkillBar from '../SkillBar.js';
import CodeBlock from '../CodeBlock.js';
import DetailsWindow from '../DetailWindow.js';
import { Fade } from 'react-reveal';
import ProjectWindow from '../ProjectWindow.js';
import { Typewriter } from 'react-simple-typewriter';
import DiagonalSection from '../DiagonalSection.js';
import '../Diagonal.css'
import { Helmet } from 'react-helmet';

export default function Home() {
    return (
      <div className="App">
        <Helmet>
          <title>Home</title>
        </Helmet>
        <HeaderBar/>
        
        <Banner
          title={"Sander Meijer"}
          description={[" ", 
            <Typewriter
              words={['Game Developer 🎮', 'Programmer 💻', 'Designer ✨', 'Team Player 💪', 'Artist 🎨', 'Coffee Enjoyer ☕']}
              cursor={true}
              loop={false}
              
            />]}
          textCol={"#fff"}
          textGradient={"linear-gradient(45deg,#12c2e9,#c471ed,#f64f59)"}
          height={"60vh"}
          image={""}
          showEffects={true}
        />
  
        <Fade bottom distance="40%" duration={750}>
          <section className='RowLayout'>
            <ProjectWindow
                icon={"https://safebuckledev.github.io/img/ras_banner.jpg"}
                name={"Run 'a Store"}
                description={"Store Simulator group project."}
                link={"/runastore"}
                workTags={['C#', 'Unity', '3D', 'AI', 'NavMesh', 'ScriptableObjects', 'GroupProject', 'Scrum', 'Git']}
            />

            <ProjectWindow
                icon={"https://safebuckledev.github.io/img/banner_td.PNG"}
                name={"Tower Defense"}
                description={"Project with a flexible wave system."}
                link={"/towerdefense"}
                workTags={['C#', 'Unity', '3D', 'AI', 'NavMesh', 'ScriptableObjects']}
            />

            <ProjectWindow
                icon={"https://safebuckledev.github.io/img/banner_ballG.png"}
                name={"Rollu"}
                description={"3D arcade ball game."}
                link={"/rollu"}
                workTags={['C#', 'Unity', '3D', 'Physics', 'Probuilder']}
            />
          </section>
        </Fade>
        
        <section className='diagonal'>
          <Fade bottom distance="40%" duration={750}>
            <h1 className='TitleText'>About Me</h1>
          </Fade>

          <Fade bottom distance="40%" duration={750}>
            <DetailsWindow
              details={"As a passionate programmer, I embarked on my coding journey at the young age of 12, and since then, my love for technology has blossomed into a lifelong pursuit. Over the years, I have honed my skills and gained extensive knowledge in a variety of programming languages and frameworks, including Unity, C#, JavaScript, React, and PHP. This diverse skill set allows me to tackle a wide range of projects, and I am always on the lookout for new challenges that will push me to grow and further develop my abilities.\n\nCreativity is the driving force behind everything I do. I firmly believe that programming is not merely a technical skill, it is an art form that allows for boundless expression and innovation. Each line of code is an opportunity to create something unique, and I relish the process of transforming ideas into reality. My ultimate goal is to share this passion with others, whether through collaboration on projects or helping others around me achieve their goals. By working together, I hope to create innovative solutions that not only meet the needs of users but also inspire and empower those around me."}
              image={""}
              textWidth={'90vh'}
              imgWidth={'0vh'}
            />
          </Fade>
        </section>

        <section>
          <Fade bottom distance="40%" duration={750}>
            <h1 className='TitleText'>My Skills</h1>
          </Fade>

          <Fade bottom distance="40%" duration={750}>
            <SkillBar
              name={"Unity"}
              percentage={"100%"}
              color={"linear-gradient(45deg,#12c2e9,#c471ed,#f64f59)"}
            />
          </Fade>
  
          <Fade bottom distance="40%" duration={750}>
            <SkillBar
              name={"C#"}
              percentage={"100%"}
              color={"linear-gradient(45deg,#12c2e9,#c471ed,#f64f59)"}
            />
          </Fade>
  
          <Fade bottom distance="40%" duration={750}>
            <SkillBar
              name={"HTML/CSS"}
              percentage={"95%"}
              color={"linear-gradient(45deg,#12c2e9,#c471ed,#f64f59)"}
            />
          </Fade>
  
          <Fade bottom distance="40%" duration={750}>
            <SkillBar
              name={"JAVASCRIPT"}
              percentage={"80%"}
              color={"linear-gradient(45deg,#12c2e9,#c471ed,#f64f59)"}
            />
          </Fade>
  
          <Fade bottom distance="40%" duration={750}>
            <SkillBar
              name={"REACT"}
              percentage={"85%"}
              color={"linear-gradient(45deg,#12c2e9,#c471ed,#f64f59)"}
            />
          </Fade>
  
          <Fade bottom distance="40%" duration={750}>
            <SkillBar
              name={"PHP"}
              percentage={"60%"}
              color={"linear-gradient(45deg,#12c2e9,#c471ed,#f64f59)"}
            />
          </Fade>
        </section>
        <FooterBar/>
      </div>
    );
  }